// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_fd-0";
export var optionCard = "_fd-1";